module.exports = __webpack_public_path__ + "img/1x.ecc64f7.jpg";